module.exports = __webpack_public_path__ + "img/pizza_dough_fold.a92362dc.jpg";